function LocalStorage() {
    this.put = function (key, value) {
        return window.localStorage.setItem(key, JSON.stringify(value));
    };

    this.get = function (key) {
        return JSON.parse(window.localStorage.getItem(key));
    };

    this.remove = function (key) {
        return window.localStorage.removeItem(key);
    };

    this.clear = function () {
        return window.localStorage.clear();
    };
}

let localStorage = new LocalStorage()
export default localStorage
